export enum Behaviours {
    EXCLUSIVE = "exclusive",
    CUMULATIVE = "cumulative"
}